import React from 'react'; 
import styled from 'styled-components';
import SessionExpireIcon from '../../../travelerProfile/components/icons/SessionExpireIcon';


const Container = styled.div`
    margin-top: 35px;
    border-radius: 5px; 
    background: #EEE;
    display: flex; 
    flex-direction: row; 
    gap: 10px;
    border-left: 17px solid #BBB;
    padding: 10px 8px;
    justify-content: center; 
    align-items: center;
`

const TextContainer = styled.div`
    display: flex; 
    flex-direction: column;
    gap: 5px;
    align-items: flex-start; 
`

const TextHeading = styled.div`
    color: #4D4D4D;
    font-family: "Open Sans";
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 120%; /* 16.96px */
    letter-spacing: 0.071px;
`; 

const TextDescription = styled.div`
    text-align: left; 
    color: #4D4D4D;
    font-family: "Open Sans";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%; /* 14.84px */
    letter-spacing: 0.031px;
`; 


function SessionExpiredCard(){

    return (
        <Container>
            <SessionExpireIcon/>
            <TextContainer>
                <TextHeading>Your session has expired</TextHeading>
                <TextDescription>You have been logged out due to inactivity. </TextDescription>
            </TextContainer>
        </Container>
    )

}

export default SessionExpiredCard; 